import React from 'react';
import { useOrderContext } from '../../../components/OrderProvider';
import Grid from '@material-ui/core/Grid';
import AcceptancesSection from './AcceptancesSection';
import AddressSection from '../../../components/AddressSection';
import CostOverviewSection from '../../../components/CostOverviewSection';
import InvoicesSection from '../../../components/InvoicesSection';
import OrderCalculationsSection from './OrderCalculationsSection';
import OrderFiles from '../OrderFiles';
import OrderProcessSection from './OrderProcessSection';
import OrderStatusSection from '../../../components/OrderStatusSection';
import PaymentDetailsSection from '../../../components/PaymentDetailsSection';
import ShippingDetailsSection from '../../../components/ShippingDetailsSection';
import ContactInformation from '@afosto/app-components-react/ContactInformation';
import OrdersSection from '@afosto/app-components-react/OrdersSection';
import ShipmentsSection from '@afosto/app-components-react/ShipmentsSection';
import OrderTagsSection from './OrderTagsSection';

const OrderDetails = () => {
  const {
    order,
    calculation,
    calculations,
    isFetchingCalculation,
    contact,
    isFetchingContact,
    organisation,
    isFetchingOrganisation,
    isFetchingAddress,
    billingAddress,
    shippingAddress,
    projection,
    invoiceIds,
    orderIds,
    shipmentIds,
  } = useOrderContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={8} xl={9}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ContactInformation
              contact={contact}
              organisation={organisation}
              isLoading={isFetchingContact || isFetchingOrganisation}
            />
          </Grid>
          <Grid item xs={12}>
            <AddressSection
              isLoading={isFetchingAddress}
              billingAddress={billingAddress}
              shippingAddress={shippingAddress}
            />
          </Grid>
          <Grid item xs={12}>
            <ShippingDetailsSection
              shipping={order?.settings?.shipping}
              shippingAddress={shippingAddress}
            />
          </Grid>
          <Grid item xs={12}>
            <PaymentDetailsSection paymentMethod={order?.settings?.billing} />
          </Grid>
          <Grid item xs={12}>
            <ShipmentsSection shipmentIds={shipmentIds} />
          </Grid>
          <Grid item xs={12}>
            <OrderCalculationsSection />
          </Grid>
          <Grid item xs={12}>
            <AcceptancesSection />
          </Grid>
          <Grid item xs={12}>
            <InvoicesSection invoiceIds={invoiceIds} />
          </Grid>
          <Grid item xs={12}>
            <OrdersSection orderIds={orderIds} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={4} xl={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <OrderStatusSection />
          </Grid>
          <Grid item xs={12}>
            <OrderTagsSection />
          </Grid>
          <Grid item xs={12}>
            <OrderProcessSection />
          </Grid>
          <Grid item xs={12}>
            <CostOverviewSection
              calculation={calculation}
              calculations={calculations}
              isLoading={isFetchingCalculation}
              projection={projection}
            />
          </Grid>
          <Grid item xs={12}>
            <OrderFiles />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrderDetails;
